//
// Load data for Ladder Predictor
//

const TEST_MODE = false

const DOMAIN = (TEST_MODE ? 'squiggle.eve' : 'squiggle.com.au')
const LOGO_URL = 'https://' + DOMAIN
const API = 'https://api.' + DOMAIN

async function dataImport(year) {

	const data = await loadAPIData(year)

	data.teams = parseData(data.teams)

	//
	// If no team has played a match yet, then throw out the standings
	// data, so we can display a "Season Not Started" message or similar.
	//
	const totalPts = data && data.standings && data.standings.reduce((total, val) => total + val.pts, 0)
	if (!totalPts) {
		data.standings = [ ]
	}

	if (data.standings && data.standings.length) {
		data.standings.forEach(row => {
			data.teams[row.id].rank = row.rank
		})
	} else if (data.prevYearStandings && data.prevYearStandings.length) {
		data.prevYearStandings.forEach(row => {
			data.teams[row.id].rank = row.rank
		})
	} else {
		Object.keys(data.teams).forEach(id =>
			data.teams[id].rank = Number(id)
		)
	}

	//
	// Signal test mode, so I don't accidentally commit the app to production with
	// test mode enabled.
	//
	data.testMode = TEST_MODE

	return data
}

//
// Receive data like: [ { id: 2, name: 'Richmond', ... }, ... ]
// and transform so that the id is the hash index,
// e.g.: data = { 2: { id: 2, name: 'Richmond', ... } },
//
function parseData(data) {
	let d = { }
	for (let dx of data) {

		// Hacky for team logos
		if (dx.logo) {
			dx.logo = LOGO_URL + dx.logo.replace(/\.jpg$/, '.png')
		}

		// Hacky to rename GWS
		if (dx.name === 'Greater Western Sydney') {
			dx.name = 'GWS'
		}

		d[dx.id || dx.gameid] = dx
	}
	return d
}

async function loadAPIData(year) {

	// All teams
	const fetchTeams = fetch( API + '?q=teams' ).then((response) => response.json())

	// All games that require tips
	const fetchLadder = fetch( API + '?q=standings;year=' + year ).then((response) => response.json())

	const t = await fetchTeams
	const l = await fetchLadder

	//
	// If we have no standings for the current year, it's probably because the season
	// hasn't started yet -- can we order teams by last year's rankings instead?
	//
	let b
	if (!l || !l.standings || !l.standings.length) {
		b = await fetch( API + '?q=standings;year=' + (year - 1)).then((response) => response.json())
	}

	return {
		teams: t.teams,
		standings: l.standings,
		prevYearStandings: b && b.standings,
	}
}

export default dataImport
